import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  Checkbox,
} from 'redux-form-material-ui';
import { push } from 'react-router-redux';
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import { renderTextField } from '../../../utils/reduxforms';

import AlertDialog from '../../Common/AlertDialog';
import { registerFormHandler, fetchStaticRoutine } from '../../../redux/routines';
import { toArray } from '../../../utils/helper';
import { required, email, password } from '../../../utils/formvalidation';
import { showError } from '../../../redux/actions/dialogs';

import LoadingOverlay from '../../Common/LoadingOverlay';

import styles from './styles';
import { isDialogVisibleSelector } from '../../../redux/selectors';
import { ALERT_DIALOG } from '../../../redux/constants/dialogs';

class Register extends Component {
  state = {
    message: '',
  };

  render() {
    const { handleSubmit, tacAccepted, submitting, isDialogVisible } = this.props;

    return (
      <div style={styles.container}>

        <div style={styles.logoContainer}><img alt="Logo" src="/images/logo.png"/></div>

        <Paper style={styles.paper}>
          <form style={styles.form} onSubmit={handleSubmit(registerFormHandler)}>
            <Grid container spacing={8}>
              <Grid xs={6} item>
                <Field
                  name="firstName"
                  component={renderTextField}
                  type="text"
                  fullWidth
                  label="First Name"
                  validate={[required]}
                />
              </Grid>
              <Grid xs={6} item>
                <Field
                  name="lastName"
                  component={renderTextField}
                  type="text"
                  fullWidth
                  label="Last Name"
                  validate={[required]}
                />
              </Grid>
              <Grid xs={12} item>
                <Field
                  name="mobile"
                  component={renderTextField}
                  type="text"
                  fullWidth
                  label="Mobile"
                  validate={[required]}
                />
              </Grid>
              <Grid xs={12} item>
                <Field
                  name="email"
                  component={renderTextField}
                  type="email"
                  fullWidth
                  label="Email"
                  validate={[required, email]}
                />
              </Grid>
              <Grid xs={12} item>
                <Field
                  name="password"
                  component={renderTextField}
                  type="password"
                  fullWidth
                  label="Password"
                  validate={[required, password]}
                />
              </Grid>
              <Grid xs={12} item>
                <FormControlLabel
                  control={<Field
                    name="tacAccepted"
                    component={Checkbox}/>}
                  label={<span>I accept the <a href="https://staza.io/terms-service.html" rel="noopener noreferrer"
                                               target="_blank">terms and conditions</a></span>}/>

              </Grid>

              <Grid xs={12} item>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  style={styles.signup}
                  disabled={!tacAccepted}
                  fullWidth
                >
                  Sign Up
                </Button>

                <div style={styles.divider}>or</div>

                <Button
                  variant="contained"
                  type="button"
                  color="secondary"
                  style={styles.login}
                  fullWidth
                  onClick={() => this.props.dispatch(push('/login'))}>
                  Login
                </Button>
              </Grid>
            </Grid>

          </form>
        </Paper>
        {isDialogVisible(ALERT_DIALOG) ? <AlertDialog/> : null}

        <LoadingOverlay visible={submitting}/>
      </div>
    );
  }
}

Register.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  tacAccepted: PropTypes.bool,
};

const form = reduxForm({
  form: 'register',  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    // dispatch(setMessage('login', 'success', 'Registration was successful. Please check your emails to verify your email address'));
    dispatch(push('/login', { message: 'Registration was successful. Please check your email to verify your email address.' }));
  },
  onSubmitFail: (errors, dispatch, submitError) => {
    console.log('onSubmitFail', errors);
    if (_.keys(errors).length > 0) {
      dispatch(showError('Registration Failed', errors[_.keys(errors)[0]]));
    } else {
      dispatch(showError('Registration Failed', 'Unknown error'));
    }

  },
})(Register);

function mapStateToProps(state) {
  const selector = formValueSelector('register');
  return {
    isDialogVisible: isDialogVisibleSelector(state),
    industries: toArray(state.getIn(['static', 'industries']).toJS()),
    tacAccepted: selector(state, 'tacAccepted'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dispatch,
    fetchIndustries: () => fetchStaticRoutine.trigger({ type: 'industries' }),
    showError,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Authentication/Register/index.js